import { useState, useRef } from "react";
import { Send } from "lucide-react";
import axios from "axios";
import { WORK_TYPES } from "@/data/forms";
import { PrivacyNote, Honeypot } from "@/components/FormExtras";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const empty = { full_name: "", phone: "", email: "", project_type: "", message: "", website: "" };

export default function QuoteForm({ compact = false }) {
  const [form, setForm] = useState(empty);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const startedAt = useRef(Date.now());

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/quotes`, { ...form, elapsed_ms: Date.now() - startedAt.current });
      setSuccess(true);
      setForm(empty);
      startedAt.current = Date.now();
      setTimeout(() => setSuccess(false), 8000);
    } catch (err) {
      setError(err.response?.data?.detail || "Une erreur est survenue");
    } finally { setLoading(false); }
  };

  return (
    <form onSubmit={handleSubmit} data-testid="quote-form" className="space-y-4 relative">
      <Honeypot value={form.website} onChange={e => setForm(f => ({ ...f, website: e.target.value }))} />
      <div className={`grid ${compact ? "grid-cols-1" : "grid-cols-1 sm:grid-cols-2"} gap-4`}>
        <input data-testid="quote-fullname" type="text" placeholder="Nom complet *" required className="input-vgi" value={form.full_name} onChange={e => setForm(f => ({ ...f, full_name: e.target.value }))} />
        <input data-testid="quote-phone" type="tel" placeholder="Téléphone *" required className="input-vgi" value={form.phone} onChange={e => setForm(f => ({ ...f, phone: e.target.value }))} />
      </div>
      <div className={`grid ${compact ? "grid-cols-1" : "grid-cols-1 sm:grid-cols-2"} gap-4`}>
        <input data-testid="quote-email" type="email" placeholder="Email *" required className="input-vgi" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} />
        <select data-testid="quote-project-type" required className="input-vgi" value={form.project_type} onChange={e => setForm(f => ({ ...f, project_type: e.target.value }))}>
          <option value="">Type de travaux *</option>
          {WORK_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
        </select>
      </div>
      <textarea data-testid="quote-message" placeholder="Décrivez votre projet..." rows={compact ? 3 : 5} className="input-vgi resize-none" value={form.message} onChange={e => setForm(f => ({ ...f, message: e.target.value }))} />
      {error && <p data-testid="quote-error" className="text-red-600 text-sm">{error}</p>}
      {success && <p data-testid="quote-success" className="text-green-600 text-sm font-semibold">Votre demande a été envoyée ! Un e-mail de confirmation vient de vous être adressé. Réponse sous 48 h.</p>}
      <button type="submit" data-testid="quote-submit" disabled={loading} className="btn-primary flex items-center justify-center gap-2 w-full sm:w-auto disabled:opacity-50">
        <Send size={16} /> {loading ? "Envoi en cours..." : "Envoyer ma demande"}
      </button>
      <PrivacyNote />
    </form>
  );
}
